import { styled } from "@mui/system";
import { Modal, Button, Divider, Accordion } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Accordion as CustomAccordion } from "../../../components/Accordion/CustomAccordion";

export const StyledApplicationOverview = styled("div")(({ theme }) => ({
  maxWidth: theme.constants.containerWidth
}));

export const StyledCommonQuestionAccordion = styled(Accordion)(({ theme }) => ({
  minWidth: "100%",
  boxShadow: "none",
  borderRadius: "20px",
  border: "2px solid #E9E9E9 !important",
  marginBottom: "24px",
  "&:before": {
    display: "none"
  },
  "&$expanded": {
    marginBottom: "24px"
  },
  [theme.breakpoints.only("xs")]: {
    minWidth: "100%"
  },
  "& .text": {
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    fontWeight: 400,
    paddingBottom: "5px",
    fontSize: "0.875rem",
    [theme.breakpoints.only("xs")]: {
      paddingBottom: 0
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem"
    }
  },
  "& .info": {
    paddingLeft: 10,
    whiteSpace: "pre-line",
    [theme.breakpoints.only("xs")]: {
      paddingLeft: 0
    },
    "& a": {
      color: "rgba(0, 0, 0, 0.87)",
      textDecoration: "underline",
      "&:hover": {
        textDecoration: "none"
      }
    }
  },
  "& .iconSize": {
    width: "20px",
    height: "10px"
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 60,
    padding: "0 16px",
    "&$expanded": {
      minHeight: 60
    },
    [theme.breakpoints.only("xs")]: {
      padding: "8px 16px !important"
    },
    "& .MuiAccordionSummary-content": {
      width: "calc(100% - 100px)",
      overflow: "hidden",
      margin: "12px 0",
      "&$expanded": {
        margin: "12px 0"
      }
    }
  },
  "& .MuiAccordionDetails-root": {
    padding: "16px",
    borderTop: "1px solid rgba(239, 242, 244, .5)",
    borderBottom: "1px solid rgba(239, 242, 244, .5)",
    fontSize: 16
  }
}));

export const StyledTwoStepGroup = styled("div")(({ theme }) => ({
  width: "100%",
  marginTop: "1.5rem",
  marginBottom: "1.5rem",
  [theme.breakpoints.up("sm")]: {
    marginTop: "3rem",
    marginBottom: "2rem"
  },
  "& .cardsWrapper": {
    display: "flex",
    padding: "1rem",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1rem",
    borderRadius: "1rem",
    border: "1px solid #DEDEDE",
    background: "#FFF",
    [theme.breakpoints.up("sm")]: {
      padding: "1.5rem"
    }
  },
  "& .cardsTitle": {
    color: "#000",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.125rem"
    }
  },
  "& .cards": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "0.5rem",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      gap: "0rem",
      alignItems: "center"
    }
  },
  "& .cardsDetails": {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      alignItems: "center",
      flexDirection: "row",
      gap: "0.75rem"
    }
  },
  "& .cardDesc": {
    margin: 0,
    color: "#000",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    marginLeft: "0.5rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
      marginLeft: "0rem"
    }
  }
}));

export const StyledTwoStepsNote = styled("div")(({ theme }) => ({
  fontSize: "12px",
  textAlign: "left",
  color: "#888888",
  paddingTop: "16px",
  paddingBottom: "16px",
  [theme.breakpoints.up("sm")]: {
    padding: "unset"
  },
  "& p": {
    color: "#000000",
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: "16px",
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "20px"
    },
    "& sup": {
      marginRight: "6px"
    },
    "& .asteriskText": {
      fontSize: "0.75rem",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "24px",
      backgroundColor: "#EB151D",
      backgroundImage: "linear-gradient(210deg, #EB151D 38.54%, #FF007A 100%)",
      backgroundSize: "100%",
      WebkitBackgroundClip: "text",
      MozBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      MozTextFillColor: "transparent"
    }
  }
}));

export const StyledAcceptedDocBtn = styled(Button)(({ theme }) => ({
  padding: "0",
  marginLeft: "0.5rem",
  width: "auto",
  color: "var(--colour-text-secondary, #4D4D4D)",
  fontSize: "0.875rem",
  fontWeight: 400,
  lineHeight: "1.25rem",
  textDecorationLine: "underline",
  textTransform: "none",
  "&:hover": {
    textDecorationLine: "underline",
    backgroundColor: "transparent"
  },
  [theme.breakpoints.up("sm")]: {
    marginLeft: "0rem"
  }
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  width: "100%",
  height: "0.0625rem",
  opacity: 0.3,
  background: "#ADADAD"
}));

export const StyledAcceptedDocumentDialog = styled(Modal)(({ theme }) => ({
  "& .MuiBox-root": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxHeight: "80%",
    display: "flex",
    padding: "2rem 1rem",
    backgroundColor: "#FFF",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1.5rem",
    borderRadius: "1rem",
    boxShadow: "0px 28px 24px -10px rgba(17, 12, 34, 0.08)",
    overflowY: "auto",
    [theme.breakpoints.up("sm")]: {
      width: "37.5rem",
      padding: "2.5rem 2rem 2rem 2rem"
    },
    [theme.breakpoints.up("lg")]: {
      height: "auto"
    }
  },
  "& .docHeaderDetails": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "1rem"
  },
  "& .heading": {
    margin: 0,
    color: "#000",
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: "1.75rem",
    paddingRight: "24px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2rem"
    }
  },
  "& .docImage": {
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
    background: "#F0F0F0",
    alignItems: "center",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "1.63rem",
      paddingBottom: "1.63rem"
    },
    "& img": {
      height: "auto",
      minHeight: "280px",
      objectFit: "contain",
      [theme.breakpoints.up("sm")]: {
        height: "auto",
        minHeight: "260px"
      }
    },
    "&.passportImg": {
      "& img": {
        maxWidth: "12rem",
        [theme.breakpoints.up("sm")]: {
          maxWidth: "15rem"
        }
      }
    }
  },
  "& .acceptedDocDetails": {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    [theme.breakpoints.up("sm")]: {
      gap: "1rem"
    }
  },
  "& .acceptedDocHeader": {
    margin: 0,
    color: "#000",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.125rem"
    }
  },
  "& .acceptedDocList": {
    margin: 0,
    paddingLeft: "1rem",
    color: "#000",
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    opacity: 0.7,
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
      lineHeight: "2rem"
    }
  }
}));

export const StyledAcceptedDocCloseBtn = styled(Button)(({ theme }) => ({
  marginTop: "1.5rem",
  display: "flex",
  padding: "0.75rem 2rem",
  justifySontent: "center",
  alignItems: "center",
  gap: "0.5rem",
  borderRadius: "62.5rem",
  background: "#1A1A1A",
  color: "#FFF",
  fontSize: "1rem",
  fontWeight: 500,
  lineHeight: "1.5rem",
  textTransform: "none",
  width: "100%",
  "&:hover": {
    background: "#1A1A1A"
  },
  [theme.breakpoints.up("sm")]: {
    marginTop: 0,
    fontSize: "1.125rem",
    padding: "1rem 2rem"
  }
}));

export const StyledAccordionWrapper = styled(CustomAccordion)(({ theme }) => ({
  "& .MuiAccordion-root": {
    borderTop: "1px solid #DEDEDE",
    borderBottom: "1px solid #DEDEDE !important",
    paddingTop: "10px",
    paddingBottom: "10px",
    "&$expanded": {
      marginBottom: "24px !important",
      paddingBottom: "24px"
    },
    [theme.breakpoints.only("sm", "md")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  "& .MuiAccordionSummary-content": {
    "& .accordionTitle": {
      "& .title": {
        fontWeight: 500,
        fontSize: "1.25rem",
        lineHeight: "36px",
        color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
        fontStyle: "normal",
        [theme.breakpoints.between("sm", "lg")]: {
          fontSize: "1.5rem"
        }
      }
    },
    "&.Mui-expanded": {
      "& .activePanel": {
        display: "none"
      },
      "& .accordionTitle": {
        paddingLeft: 0
      }
    }
  },
  "& .MuiAccordionDetails-root": {
    paddingTop: "0px",
    marginTop: "0px",
    marginBottom: "0px"
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    fill: "#000000",
    width: "20px",
    height: "10px",
    "& svg": {
      fill: "#000000"
    }
  },
  "& .subTitle": {
    color: "#555",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "28px",
    marginBottom: "24px 0",
    [theme.breakpoints.between("sm", "lg")]: {
      fontSize: "1.125rem"
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.25rem"
    }
  }
}));

export const StyledImportantNote = styled("div")(({ theme }) => ({
  marginBottom: "1.5rem",
  [theme.breakpoints.up("sm")]: {
    marginBottom: "3rem"
  },
  "& .importantNoteApplicationOverview": {
    "&.titleWrapper": {
      gap: "0rem",
      marginBottom: "1.5rem",
      [theme.breakpoints.up("sm")]: {
        marginBottom: "2rem"
      }
    },
    "& .title": {
      fontSize: "1.25rem"
    }
  }
}));

export const StyledStartApplicationBtnSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "1.5rem",
  marginBottom: "1.75rem",
  gap: "0.5rem",
  "& .MuiButton-root": {
    display: "flex",
    padding: "1rem 2rem",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    borderRadius: "62.5rem",
    background: "#1A1A1A",
    color: "#FFF",
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    textTransform: "none",
    "&:hover": {
      opacity: 0.8
    },
    "& .arrowRightIcon": {
      fill: "#fff"
    },
    "&.backBtn": {
      color: "#000",
      background: "#FFF",
      border: "1px solid #1A1A1A",
      "& .arrowIcon": {
        fill: "#000",
        "& path": {
          fill: "#000"
        }
      }
    }
  }
}));

export const StyledModalCloseIcon = styled(CloseIcon)(({ theme }) => ({
  position: "absolute",
  top: "2rem",
  right: "1rem",
  width: "24px",
  height: "24px",
  fill: "#525252",
  PointerEvent: "cursor",
  [theme.breakpoints.up("sm")]: {
    right: "2rem",
    top: "2.5rem"
  }
}));
